/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AddUserToCourseRequest } from './addUserToCourseRequest';

export type AddCoursestudentBody = AddUserToCourseRequest | null;
